import './CalculatingProgressBar.scss';

const CalculatingProgressBar = () => (
    <div className="CalculatingProgressBar position-fixed overflow-hidden">
        <div className="CalculatingProgressBar__bar h-100 bg-primary" />
    </div>
);

export default CalculatingProgressBar;
